/*
 *   File : portfolio.js
 *   Author : https://evoqins.com
 *   Description : portfolio tab file
 *   Integrations : NA
 *   Version : 1.0.0
*/

import React, { useEffect, useRef, useState } from 'react'
import { useLocation, useNavigate, useParams } from 'react-router-dom';

//Style
import style from "../../../Style/Component/portfolio.module.scss";

//Custom components
import { CustomTab, EmptyScreen, Loader } from '../../../Components/Others';
import { PieChart } from '../../../Components/Chart';
import { _formatToRupees } from '../../../Helper';
import { BasketDetail, ExternalHoldings, FundDetail, GoalDetail, InternalHoldings } from './';
import { APIService } from '../../../Service';
import { Icon } from '../../../Components/Icon';


const TAB_DATA = [
    {
        id: 1,
        label: "Overview"
    },
    {
        id: 2,
        label: "Holdings"
    },
    {
        id: 3,
        label: "External"
    }
];

const TAB_VALUE_DATA = [
    {
        id: 1,
        label: "Goals"
    },
    {
        id: 3,
        label: "Smart Basket"
    },
    {
        id: 5,
        label: "Insta Save"
    },
    {
        id: 4,
        label: "Gold Maxx"
    },
    {
        id: 2,
        label: "Self Managed"
    },
];

const Portfolio = () => {

    const { state } = useLocation();
    const navigate = useNavigate();
    const location = useLocation();
    const { id } = useParams();
    const scrollRef = useRef(null);

    const [tabIndex, setTabIndex] = useState(0);
    const [toggleXirr, setToggleXirr] = useState(false);

    const [isDetail, setIsDetail] = useState(false);
    const [detailType, setDetailType] = useState('');

    const [loader, setLoader] = useState(true);
    const [portfolioData, setPortfolioData] = useState({});

    const [portfolioDetailData, setPortfolioDetailData] = useState({});
    const [detailLoader, setDetailLoader] = useState(true);

    const [historyData, setHistoryData] = useState({});
    const [modalHistoryData, setModalHistoryData] = useState({});
    const [historyLoader, setHistoryLoader] = useState(false);
    const [modalHistoryLoader, setModalHistoryLoader] = useState(false);

    const [investmentType, setInvestmentType] = useState(null);
    const [investmentId, setInvestmentId] = useState(null);

    const [forcedLoader, setForcedLoader] = useState(false);

    const [activeSipData, setActiveSipData] = useState({});

    const [overviewData, setOverviewData] = useState({});
    const [tabValue, setTabValue] = useState(0);

    console.log("tabValue", tabValue);


    useEffect(() => {
        if (state !== null) {
            if (state?.portfolio_tab_index) {
                setTabIndex(state.portfolio_tab_index);
            } else {
                setTabIndex(1);
            }
            if (state?.portfolio_inner_tab_index) {
                setTabValue(state.portfolio_inner_tab_index);
            } else {
                setTabValue(1);
            }
        } else {
            setTabIndex(1);
            setTabValue(1);
        }
        setIsDetail(false);
    }, [state]);


    useEffect(() => {
        if (tabIndex !== 0) {
            _getPortfolio();
        }
    }, [tabIndex]);

    useEffect(() => {
        let pieChartTooltip = document.getElementById('chartjs-tooltip');
        if (pieChartTooltip) {
            pieChartTooltip.style.opacity = 0;
        }
    }, [tabIndex]);


    // handle tab change 
    const _handleTabChange = (tab_id) => {
        navigate(location.pathname.includes("support") ? `/support/${id}` : `/customers/${id}`, {
            state: {
                ...state,
                portfolio_tab_index: tab_id,
            }
        });
    };

    // handle toggle sort 
    const _handleToggle = () => {
        setToggleXirr(prev => !prev)
    };

    const _handleNavigate = (navigation_id) => {
        setLoader(true);

        if (navigation_id === 6) {
            navigate(location.pathname.includes("support") ? `/support/${id}` : `/customers/${id}`, {
                state: {
                    ...state,
                    portfolio_tab_index: 3,
                    // portfolio_inner_tab_index: 1
                }
            });
        } else {
            navigate(location.pathname.includes("support") ? `/support/${id}` : `/customers/${id}`, {
                state: {
                    ...state,
                    portfolio_tab_index: 2,
                    portfolio_inner_tab_index: navigation_id
                }
            });
        }
        if (scrollRef.current) {
            scrollRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' })
        }
    };

    const _handleDetail = (holding_tab, investment_id) => {
        if (scrollRef.current) {
            scrollRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' })
        }
        _getPortfolioDetail(holding_tab, investment_id)

        _detailOrder(holding_tab, investment_id, 1, true)

        if (holding_tab === 1) {
            setDetailType('goal');
        } else if (holding_tab === 3) {
            setDetailType('basket');
        } else if (holding_tab === 5) {
            setDetailType('instasave');
        } else if (holding_tab === 4) {
            setDetailType('goldmaxx');
        } else if (holding_tab === 2) {
            setDetailType('self-managed');
        }
        setIsDetail(true);


        _getSipData(holding_tab, investment_id);
    };

    // API - Get portfolio
    const _getPortfolio = () => {
        let is_post = true;
        let url = 'user/get-portfolio';
        let request = {
            "customer_id": id,
            "is_external": tabIndex === 1 ? null : tabIndex === 2 ? false : true
        };

        setLoader(true);
        APIService(is_post, url, request).then((response) => {
            if (response.status_code === 200) {
                setPortfolioData(response.data);
            } else {
                setPortfolioData({});
            }
            setLoader(false);
        })
    };


    // API - Get portfolio detail
    const _getPortfolioDetail = (investment_type, investment_id) => {
        setDetailLoader(true);
        let is_post = true;
        let url = 'user/get-detail';
        let request = {
            "customer_id": id,
            "investment_type": investment_type,
            "id": investment_id
        };

        APIService(is_post, url, request).then((response) => {
            if (response.status_code === 200) {
                setPortfolioDetailData(response.data);
            } else {
                setPortfolioDetailData({});
            }
            setDetailLoader(false);
        })
    };


    // API -user detail
    const _detailOrder = (investment_type, investment_id, page_num, is_initial) => {
        let is_post = true;
        let url = 'user/list-order';
        let request = {
            "page_num": page_num,
            "page_size": 10,
            "customer_id": id,
            "investment_type": investment_type,
            "investment_id": investment_id
        }

        setInvestmentType(investment_type);
        setInvestmentId(investment_id);


        if (is_initial === true) {
            setHistoryLoader(true);
        }
        setModalHistoryLoader(true);

        APIService(is_post, url, request).then((response) => {
            if (response.status_code === 200) {
                if (is_initial === true) {
                    setHistoryData(response.data);
                }
                setModalHistoryData(response.data);
            } else {
                setHistoryData({ orders: [] });
                setModalHistoryData({ orders: [] });
            }
            setHistoryLoader(false);
            setModalHistoryLoader(false);
            setForcedLoader(false);
        });
    };

    // API - Get Sip data
    const _getSipData = (investment_type, investment_id) => {
        let is_post = true;
        let url = 'user/active-sip';
        let request = {
            "page_num": 1,
            "investment_type": investment_type,
            "investment_id": investment_id,
            "customer_id": id
        };

        APIService(is_post, url, request).then((response) => {
            if (response.status_code === 200) {
                setActiveSipData(response.data);
            } else {
                setActiveSipData({});
            }
        })
    };

    return (
        <div ref={scrollRef} className={`${style.e_portfolio_wrapper} d-flex flex-column gap-4 padding-32px-all min-vh-100`}>

            {isDetail === false ?
                <>
                    <div className='row'>
                        <div className='col-7'>
                            <div className='d-sm-flex justify-content-between gap-2 align-items-center justify-content-xl-between pb-2'>
                                {/* Custom tab */}
                                <div className='d-flex gap-12px'>
                                    <CustomTab data={TAB_DATA}
                                        selectedTab={tabIndex}
                                        type={2}
                                        handleClick={_handleTabChange} />
                                </div>

                                <div className='d-flex gap-6px align-items-center justify-content-end  cursor-pointer'
                                    onClick={_handleToggle}>
                                    <p className="mb-0 w-max-content e-text-princeton-orange e-alt-font e-font-14 e-font-weight-500 line-height-16px">
                                        {toggleXirr ? "XIRR" : "Absolute"} (%)
                                    </p>
                                    <img src={require("../../../Assets/Image/Others/arrow-toggle.svg").default}
                                        alt='arrow toggle' />
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* DASHBOARD */}
                    {loader ?
                        <Loader />
                        :
                        <>
                            <div className='row'>
                                <div className='col-7'>
                                    {tabIndex === 1 || tabIndex === 3 ?
                                        <div className={`${style.e_portfolio_card_wrapper} e-bg-white p-4 border-radius-12  `}>
                                            <div className='d-flex align-items-start abs justify-content-between'>
                                                <div className='d-flex flex-column row-gap-14px mb-1'>
                                                    <h4 className='mb-0  d-flex align-items-center mb-0 e-text-blue-violet e-alt-font e-font-16 e-font-weight-700 line-height-18px letter-spacing-2px'>
                                                        DASHBOARD
                                                    </h4>
                                                    <span className=' e-text-dark-gray e-alt-font e-font-10 e-font-weight-400 line-height-12px'>
                                                        as on: {portfolioData?.as_on_date?.day !== "-" ? <span className='e-font-14 e-text-blue-violet e-font-weight-600'>
                                                            {portfolioData?.as_on_date?.day}<sup className='e-text-dark-gray'>th</sup> {portfolioData?.as_on_date?.month}</span> : "-"}
                                                    </span>

                                                </div>
                                            </div>
                                            <div className='d-flex mt-2 gap-14px flex-column'>
                                                <div className="d-flex justify-content-between">
                                                    <p className='mb-0 e-text-davys-grey e-alt-font e-font-14 e-font-weight-600 line-height-16px'>
                                                        Current value
                                                    </p>
                                                    <p className={`${portfolioData?.dashboard?.current_amount < 0 ? "e-text-carmine-pink" :
                                                        portfolioData?.dashboard?.current_amount > 0 ? "e-text-green-crayola" : "e-text-smoky-black"} mb-0 e-alt-font e-font-18 e-font-weight-600 line-height-20px `}>
                                                        {portfolioData?.dashboard?.current_amount_text}
                                                    </p>

                                                </div>
                                                <div className='d-flex justify-content-between'>
                                                    <p className='mb-0 e-text-davys-grey e-alt-font e-font-14 e-font-weight-600 line-height-16px'>
                                                        Invested Amount
                                                    </p>
                                                    <p className={`${portfolioData?.dashboard?.invested_amount < 0 ? "e-text-carmine-pink" :
                                                        portfolioData?.dashboard?.invested_amount > 0 ? "e-text-green-crayola" : "e-text-smoky-black"} mb-0 e-text-smoky-black e-alt-font e-font-18 e-font-weight-600 line-height-20px`}>
                                                        {portfolioData?.dashboard?.invested_amount_text}
                                                    </p>
                                                </div>
                                                <div className='d-flex justify-content-between'>
                                                    <p className='mb-0 e-text-davys-grey e-alt-font e-font-14 e-font-weight-600 line-height-16px'>
                                                        {toggleXirr ? " XIRR Returns" : "Absolute Returns"}
                                                    </p>
                                                    <p className={`${portfolioData?.dashboard?.returns_amount < 0 ? "e-text-carmine-pink" :
                                                        portfolioData?.dashboard?.returns_amount > 0 ? "e-text-green-crayola" : "e-text-smoky-black"} mb-0 e-alt-font e-font-18 e-font-weight-600 line-height-20px`}>
                                                        {portfolioData?.dashboard?.returns_amount_text}
                                                        {
                                                            toggleXirr ?
                                                                <span className={`${portfolioData?.dashboard?.xirr < 0 ? "e-text-carmine-pink" :
                                                                    portfolioData?.dashboard?.xirr > 0 ? "e-text-green-crayola" : "e-text-smoky-black"}  e-font-weight-400 e-font-14`}>({portfolioData?.dashboard?.xirr_text})</span>
                                                                :
                                                                <span className={`${portfolioData?.dashboard?.returns_percentage < 0 ? "e-text-carmine-pink" :
                                                                    portfolioData?.dashboard?.returns_percentage > 0 ? "e-text-green-crayola" : "e-text-smoky-black"}  e-font-weight-400 e-font-14`}>({portfolioData?.dashboard?.returns_percentage_text})</span>
                                                        }
                                                    </p>
                                                </div>
                                                <div className='d-flex justify-content-between'>
                                                    <p className='mb-0 e-text-davys-grey e-alt-font e-font-14 e-font-weight-600 line-height-16px'>
                                                        1 Day Change
                                                    </p>
                                                    <p className={`${portfolioData?.dashboard?.one_day_returns < 0 ? "e-text-carmine-pink" :
                                                        portfolioData?.dashboard?.one_day_returns > 0 ? "e-text-green-crayola" : "e-text-smoky-black"} mb-0 e-alt-font e-font-18 e-font-weight-600 line-height-20px`}>
                                                        {portfolioData?.dashboard?.one_day_returns_text}
                                                        <span className={`e-font-weight-400 e-font-14`}>
                                                            ({portfolioData?.dashboard?.one_day_returns_percentage_text})
                                                        </span>
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                        :
                                        <div className={`${style.e_portfolio_card_wrapper} e-bg-white p-4 border-radius-12  `}>
                                            <div className='d-flex align-items-start abs justify-content-between'>
                                                <div className='d-flex flex-column row-gap-14px mb-1'>
                                                    <h4 className='mb-1  d-flex align-items-center mb-0 e-text-blue-violet e-alt-font e-font-16 e-font-weight-700 line-height-18px letter-spacing-2px'>
                                                        {/* SUMMARY - {
                                                            TAB_VALUE_DATA.find(item => item.id === item.id === tabValue)?.label
                                                        } */}

                                                        SUMMARY - {tabValue === 1 ? "Goals" : tabValue === 2 ? "Self Managed" : tabValue === 3 ? "Smart Basket" : tabValue === 4 ? "Gold Maxx" : "Insta Save"}
                                                    </h4>

                                                </div>
                                            </div>
                                            <div className='d-flex mt-2 gap-14px flex-column'>
                                                <div className="d-flex justify-content-between">
                                                    <p className='mb-0 e-text-davys-grey e-alt-font e-font-14 e-font-weight-600 line-height-16px'>
                                                        Current value
                                                    </p>
                                                    <p className={`${overviewData?.dashboard?.current_amount < 0 ? "e-text-carmine-pink" :
                                                        overviewData?.dashboard?.current_amount > 0 ? "e-text-green-crayola" : "e-text-smoky-black"} mb-0 e-alt-font e-font-18 e-font-weight-600 line-height-20px `}>
                                                        {overviewData?.dashboard?.current_amount_text}
                                                    </p>

                                                </div>
                                                <div className='d-flex justify-content-between'>
                                                    <p className='mb-0 e-text-davys-grey e-alt-font e-font-14 e-font-weight-600 line-height-16px'>
                                                        Invested Amount
                                                    </p>
                                                    <p className={`${overviewData?.dashboard?.invested_amount < 0 ? "e-text-carmine-pink" :
                                                        overviewData?.dashboard?.invested_amount > 0 ? "e-text-green-crayola" : "e-text-smoky-black"} mb-0 e-text-smoky-black e-alt-font e-font-18 e-font-weight-600 line-height-20px`}>
                                                        {overviewData?.dashboard?.invested_amount_text}
                                                    </p>
                                                </div>
                                                <div className='d-flex justify-content-between'>
                                                    <p className='mb-0 e-text-davys-grey e-alt-font e-font-14 e-font-weight-600 line-height-16px'>
                                                        {/* {toggleXirr ? " XIRR Returns" : "Absolute Returns"} */}
                                                        Absolute Returns
                                                    </p>
                                                    <p className={`${overviewData?.dashboard?.returns_amount < 0 ? "e-text-carmine-pink" :
                                                        overviewData?.dashboard?.returns_amount > 0 ? "e-text-green-crayola" : "e-text-smoky-black"} mb-0 e-alt-font e-font-18 e-font-weight-600 line-height-20px`}>
                                                        {overviewData?.dashboard?.returns_amount_text}
                                                        {/* {
                                                            toggleXirr ?
                                                                <span className={`${overviewData?.dashboard?.xirr < 0 ? "e-text-carmine-pink" :
                                                                    overviewData?.dashboard?.xirr > 0 ? "e-text-green-crayola" : "e-text-smoky-black"}  e-font-weight-400 e-font-14`}>({overviewData?.dashboard?.xirr_text})</span>
                                                                : */}
                                                        <span className={`${overviewData?.dashboard?.returns_percentage < 0 ? "e-text-carmine-pink" :
                                                            overviewData?.dashboard?.returns_percentage > 0 ? "e-text-green-crayola" : "e-text-smoky-black"}  e-font-weight-400 e-font-14`}>({overviewData?.dashboard?.returns_percentage_text})</span>
                                                        {/* } */}
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    }

                                </div>
                            </div>

                            <div className='row'>
                                <div className={tabIndex === 1 ? "col-7" : "col-10"}>
                                    {tabIndex === 1 ?
                                        <>
                                            {portfolioData?.graph?.length !== 0 &&
                                                <div className=' e-bg-white w-100 border-radius-12 p-4 e-border-2px-dashed-bright-gray-dark'>
                                                    <h4 className='ps-0 e-text-dark-gray e-alt-font e-font-16 e-font-weight-600 line-height-18px margin-14px-bottom'>
                                                        Holdings Breakdown
                                                    </h4>
                                                    <div className="row">
                                                        <div className="col text-center">
                                                            <div className=" d-flex flex-sm-wrap align-items-center justify-content-center">
                                                                {/* Pie chart */}
                                                                <div className='e-chart col-sm-6 pt-md-3  pt-lg-0'>
                                                                    <div className='d-sm-flex justify-content-center'>
                                                                        <PieChart data={portfolioData?.graph?.map((item) => item.value)}
                                                                            label={portfolioData?.graph?.map((item) => item.label)}
                                                                            colors={portfolioData?.graph?.map((item) => item.color)}
                                                                            paths={portfolioData?.graph?.map((item) => item.id)}
                                                                            onNavigate={_handleNavigate} />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <table className='e-holdings-break-table mt-3 '>
                                                        <tr>
                                                            <th className="e-text-dark-gray e-alt-font e-font-16 e-font-weight-600 line-height-24px">
                                                                Product
                                                            </th>
                                                            <th className="e-text-dark-gray e-alt-font e-font-16 e-font-weight-600 line-height-24px">
                                                                Current value (%)
                                                            </th>
                                                        </tr>
                                                        {
                                                            portfolioData?.graph?.map((item) => (
                                                                <tr>
                                                                    <td>
                                                                        <div className="d-flex align-items-center gap-1">
                                                                            <div className='w-12px h-12px e-border-2px-platinum rounded-circle' style={{ background: item.color }}></div>
                                                                            <p className="mb-0 e-text-dark-gray e-alt-font e-font-14 e-font-weight-400 line-height-18px">
                                                                                {item.label}
                                                                            </p>
                                                                        </div>
                                                                    </td>
                                                                    <td>
                                                                        <span className="e-text-dark-gray e-alt-font e-font-14 e-font-weight-400 line-height-18px">
                                                                            {item.amount} ({item.value_text})
                                                                        </span>
                                                                    </td>
                                                                </tr>
                                                            ))
                                                        }
                                                    </table>
                                                </div>
                                            }
                                        </>

                                        :
                                        tabIndex === 2 ?
                                            <InternalHoldings
                                                portfolioDetails={portfolioData}
                                                toggleXirr={toggleXirr}
                                                overviewData={(data) => setOverviewData(data)}
                                                handleDetail={_handleDetail}
                                                handleTab={(tab) => setTabValue(tab)} />
                                            :
                                            tabIndex === 3 ?
                                                <ExternalHoldings
                                                    portfolioDetails={portfolioData}
                                                    toggleXirr={toggleXirr} />
                                                :
                                                null
                                    }
                                </div>
                            </div>
                        </>
                    }
                </>
                :
                <>

                    {detailLoader ?
                        <Loader className="pt-5 mt-5" />
                        :
                        <>
                            {portfolioDetailData && Object.keys(portfolioDetailData).length !== 0 ?
                                <>

                                    <div className=' d-flex gap-3 align-items-center cursor-pointer w-max-content'
                                        onClick={() => {
                                            setIsDetail(false);
                                            setDetailType('');
                                        }}>
                                        <Icon icon="back"
                                            className="d-flex"
                                            color="#292D32"
                                            size={32} />
                                        <span className='e-text-custom-blue e-alt-font e-font-18 e-font-weight-600 line-height-22px'>
                                            {portfolioDetailData?.dashboard?.name}
                                        </span>
                                    </div>
                                    {detailType === 'goal' ?
                                        <GoalDetail data={portfolioDetailData}
                                            orderHistory={historyData}
                                            historyLoader={historyLoader}
                                            modalHistoryData={modalHistoryData}
                                            modalHistoryLoader={modalHistoryLoader}
                                            forcedLoader={forcedLoader}
                                            activeSip={activeSipData}
                                            handleViewMore={() => _detailOrder(investmentType, investmentId, modalHistoryData.current_page + 1, false)}
                                            handleViewHistory={() => {
                                                if (investmentType !== null) {
                                                    _detailOrder(investmentType, investmentId, 1, false);
                                                    setForcedLoader(true);
                                                }
                                            }}
                                            handleClose={() => setModalHistoryData({})}
                                            handleBack={() => {
                                                setIsDetail(false);
                                                setDetailType('');
                                            }} />
                                        :
                                        detailType === 'basket' ?
                                            <BasketDetail data={portfolioDetailData}
                                                orderHistory={historyData}
                                                historyLoader={historyLoader}
                                                modalHistoryData={modalHistoryData}
                                                modalHistoryLoader={modalHistoryLoader}
                                                forcedLoader={forcedLoader}
                                                activeSip={activeSipData}
                                                handleViewMore={() => _detailOrder(investmentType, investmentId, modalHistoryData.current_page + 1, false)}
                                                handleViewHistory={() => {
                                                    if (investmentType !== null) {
                                                        _detailOrder(investmentType, investmentId, 1, false);
                                                        setForcedLoader(true);
                                                    }
                                                }}
                                                handleClose={() => setModalHistoryData({})}
                                                handleBack={() => {
                                                    setIsDetail(false);
                                                    setDetailType('');
                                                }} />
                                            :
                                            detailType === 'instasave' || detailType === 'goldmaxx' || detailType === 'self-managed' ?
                                                <FundDetail data={portfolioDetailData}
                                                    detailType={detailType}
                                                    orderHistory={historyData}
                                                    historyLoader={historyLoader}
                                                    modalHistoryData={modalHistoryData}
                                                    modalHistoryLoader={modalHistoryLoader}
                                                    forcedLoader={forcedLoader}
                                                    activeSip={activeSipData}
                                                    handleViewMore={() => _detailOrder(investmentType, investmentId, modalHistoryData.current_page + 1, false)}
                                                    handleViewHistory={() => {
                                                        if (investmentType !== null) {
                                                            _detailOrder(investmentType, investmentId, 1, false);
                                                            setForcedLoader(true);
                                                        }
                                                    }}
                                                    handleClose={() => setModalHistoryData({})}
                                                    handleBack={() => {
                                                        setIsDetail(false);
                                                        setDetailType('');
                                                    }} />
                                                :
                                                null
                                    }
                                </>
                                :
                                <EmptyScreen
                                    image={require('../../../Assets/Image/NotFound/no-data.png')}
                                    title='No data found'
                                    className="min-vh-100"
                                    description={``}
                                />
                            }

                        </>
                    }
                </>
            }
        </div>
    )
}

export default Portfolio;
